
import { Component, input } from '@angular/core';
import { Observable } from 'rxjs';
import { AppCommonModule } from 'src/app/common.module';
import { SnapLinkComponent } from './item/snap-link.component';

export interface SnapLink {
  name: string;
  icon?: string;
  title?: string;
  notification?: number;
  notification$?: Observable<number>;
  action: () => void;
}

@Component({
  selector: 'app-snap-links',
  templateUrl: './snap-links.component.html',
  styleUrls: ['./snap-links.component.scss'],
  imports: [
    AppCommonModule,
    SnapLinkComponent,
  ],
})
export class SnapLinksComponent {
  items = input<SnapLink[]>();
}
